"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getSelectedDateOffset;

var defaultModifier = function defaultModifier(day) {
  return day;
};

function getSelectedDateOffset(fn, day) {
  var modifier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultModifier;
  if (!fn) return day;
  return modifier(fn(day.clone()));
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-dates/lib/utils/getSelectedDateOffset.js
 ** module id = 1250
 ** module chunks = 0
 **/